module.exports = __webpack_public_path__ + "img/post.3c726c2a.jpg";